import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const Loader = () => {
  return (
    <div className="dFA jcC">
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    </div>
  );
};

export default Loader;
